<template>
 <div  v-if="isLoading" class="calculation-spinner flex flex-center">
    <q-spinner-facebook size="3em" color="primary" />
</div>
<div v-else>
      <div   v-if="!getGatheringProcess||(getGatheringProcess && getGatheringProcess.length ===0)" class="text-deep-black-4 font-weight-normal mt-3">
          <span>  {{ $t("order.orderActions.NoActionsFound") }}  </span>
      </div> 
  <q-expansion-item switch-toggle-side
                    header-class=" card-header bg-transparent no-border p-4 tw-order-summaryPanel-header-class default-border-radius"
                    class="tw-items-dashed-group tw-items-group-with-bg tw-level-two-group q-expansion-item--expanded"
                    @show="" @hide=""
                    v-for="(gatheringProcess, index) in getGatheringProcess" :key="index">
    <template v-slot:header>
      <div class="card-title flex-grow-1 justify-content-between align-items-center mb-0">
        <div class="d-flex align-items-center">
          <div class="font-semi-bold font-size-12">
            {{
              capitalize(
                  $t("order.preconditions.label." + gatheringProcess.assessmentContext).toLowerCase()
              )
            }}
          </div>

        </div>
      </div>
    </template>
    <div class="default-border-radius p-2 bg-white">
      <div v-for="(checkpoint, index) in gatheringProcess.checkpoints" :key="index" class="mb-2">
        <div v-if="checkpoint.objectType.includes('documentvalue')">
          <div v-for="(document, i) in checkpoint.documents" :key="i" class="row d-flex align-items-center">
            <div>
              <span :class="setStatusBadgeClass(document.status||'PENDING')">
                {{$t('task.uploadDocument.headers.supportingDocumentStatus.'.concat(document.status||'PENDING'))}}
              </span>
            </div>
            <div class="pl-3 flex-fill">
              <span>
                {{ $t('task.supportingDocumentLabel.'.concat(document.documentType)) }}
              </span>
            </div>
          </div>
        </div>
        <div class="row d-flex align-items-center" v-if="checkpoint.objectType.includes('fieldvalue')">
          <div>
            <span :class="setStatusBadgeClass(checkpoint.status.resourceUid)">
              {{ $t('order.preconditions.fieldvalue.status.'.concat(checkpoint.status.resourceUid)) }}
            </span>
          </div>
          <div class="pl-3 flex-fill">
            <span>
              {{ $t("order.preconditions.fieldvalue.label." + checkpoint.i18nLabel) }}
            </span>
          </div>
        </div>
        <div class="row d-flex align-items-center" v-if="checkpoint.objectType.includes('businessrulevalue')">
          <div>
            <span :class="setStatusBadgeClass(checkpoint.status.resourceUid)">
              {{ $t('order.preconditions.fieldvalue.status.'.concat(checkpoint.status.resourceUid)) }}
            </span>
          </div>
          <div class="pl-3 flex-fill">
            <span>
              {{ $t("order.preconditions.fieldvalue.label." + checkpoint.i18nLabel) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </q-expansion-item>
  </div>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";
import LabelAndValue from "@/components/general/LabelAndValue.vue";
import {formatWithMask} from "@/utils/configuration/formatters-config";
import store from "@/store";
import {globalConfig} from "@/utils";
import { processDocumentsOrder } from "@/commons/gathering-process-order";
import { getRequiredDocumentValidatedByBRBatch } from "@/store/services/task/actions/uploadDocumentService";

@Options({
  methods: {formatWithMask},
  components: {LabelAndValue},
  props: [""],
})
export default class OrderSummaryPreConditions extends Vue {
  capitalize = globalConfig.capitalize;
  orderCheckPoints: any[] = [];
  ListGatheringProcessAssociated: any[] = [];
  isLoading = true


  setStatusBadgeClass(value: string) {
    switch (value) {
      case 'COMPLETED':
        return "badge badge-primary";
      case 'QUALIFIED':
        return "badge badge-primary";
      case 'PENDING':
        return "badge badge-danger";
      default:
        return "";
    }

  }

  get getGatheringProcess() {
    return store.state.summaryPanelModule.gatheringProcessOrder;
  }

  get order(){
   return store.state.summaryPanelModule.order
  }

  async orderProcess(ListGatheringProcessAssociated: any) {
    this.ListGatheringProcessAssociated = ListGatheringProcessAssociated;

    const validProcesses = this.ListGatheringProcessAssociated.filter(
      (gp: any) => gp.gatheringProcess && gp.gatheringProcess.rawData
    );
    const processIds = validProcesses.map(
      (gp: any) => gp.gatheringProcess.resourceUid
    );

    if (processIds.length === 0) {
      this.isLoading = false;
      return;
    }

    try {
      const batchResult = await getRequiredDocumentValidatedByBRBatch(
        processIds,
        store.state.summaryPanelModule.order!.resourceUid as string,
        "summaryPanelModule"
      );

      for (const GatheringProcess of validProcesses) {
        const processId = GatheringProcess.gatheringProcess.resourceUid;
        const requiredDocuments = batchResult[processId] || [];
        await processDocumentsOrder({
          gatheringProcess: GatheringProcess.gatheringProcess.rawData,
          requiredDocuments: requiredDocuments,
          supportingDocuments: GatheringProcess.gatheringProcess.rawData.supportingDocuments,
          receivedFiles: GatheringProcess.gatheringProcess.rawData.gatheringProcessItem[0].receivedFiles,
          module: "summaryPanelModule",
        });
      }
    } catch (e) {
      console.error("OrderSummaryPreConditions error", e);
    } finally {
      this.isLoading = false;
    }
  }

  created() {
    if (store.state.summaryPanelModule.order&&store.state.summaryPanelModule.order.resourceUid
    &&store.state.summaryPanelModule.order.orderGatheringProcess
    &&store.state.summaryPanelModule.order.orderGatheringProcess.length>0
    ) {
    store.dispatch("summaryPanelModule/gatheringProcessOrder", {
            request: {
                gatheringProcess: [],
            },
        })
    this.orderProcess(store.state.summaryPanelModule.order.orderGatheringProcess)
    }
    else {
      this.isLoading = false
    }
  }

}
</script>

<style scoped></style>
	